import About from "../components/About";
import Contact from "../Contact";
import LayoutMain from "../LayoutMain";
import Skills from "../Skills";
import Works from "../Works";

const routes = [
  { id: 1, path: "/", element: <LayoutMain /> },
  { id: 2, path: "about", element: <About /> },
  { id: 3, path: "skills", element: <Skills /> },
  { id: 4, path: "works", element: <Works /> },
  { id: 5, path: "contact", element: <Contact /> },
];
export default routes;
